"use strict";
exports.__esModule = true;
exports.fileDownload = void 0;
/**
 * Function to create a download hyperlink and initiate file download
 * @param file the file data (blob) which is to be downloaded
 * @param filename name of the file w/ its extension
 */
exports.fileDownload = function (fileData, filename) {
    var file = window.URL.createObjectURL(fileData);
    var downloadLink = document.createElement('a');
    downloadLink.setAttribute('id', 'downloadLink');
    downloadLink.download = filename;
    downloadLink.href = file;
    downloadLink.click();
    var myElement = document.getElementById('downloadLink');
    if (myElement !== null) {
        myElement.remove();
    }
};
